export class HuobiDepositAddress {
  id: string;
  userId: number;
  currency: string;
  address: string;
  addressTag: string;
  chain: string;
}
